import React from "react";
import "./ChartTooltip.sass";

/**
 * Hover / keyboard-focus tooltip shown under its child (spec §2), or above it
 * with an arrow pointing at it.
 *
 * @param {object} props
 * @param {string} props.label - tooltip text
 * @param {"bottom"|"top"} [props.placement] - under the child, or above it with an arrow
 * @param {"large"} [props.size] - the bigger Moon-like box
 * @param {React.ReactNode} props.children - the anchor element
 */
const ChartTooltip = ({ label, placement = "bottom", size, children }) => (
  <span
    className={`chart-tooltip chart-tooltip--${placement}${size ? ` chart-tooltip--${size}` : ""}`}
  >
    {children}
    <span className="chart-tooltip__text" role="tooltip">
      {label}
    </span>
  </span>
);

export default ChartTooltip;
